import React from "react";

const QuantityReceived = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_5669_2)">
        <rect
          x="4"
          y="4.14062"
          width="16"
          height="16.2909"
          rx="4"
          fill="#FFE0C1"
          fill-opacity="0.5"
          shape-rendering="crispEdges"
        />
      </g>
      <path
        d="M17.5135 13.7959C17.3535 13.6559 17.1335 13.5959 16.9135 13.6359L15.0935 13.9559V9.03594C15.0935 8.91594 15.0135 8.83594 14.8935 8.83594H9.59336C9.47336 8.83594 9.39336 8.91594 9.39336 9.03594V13.4958L7.65336 13.5958V13.0158C7.65336 12.8958 7.57336 12.8158 7.45336 12.8158H6.39336C6.27336 12.8158 6.19336 12.8958 6.19336 13.0158V16.8759C6.19336 16.9959 6.27336 17.0759 6.39336 17.0759H7.45336C7.57336 17.0759 7.65336 16.9959 7.65336 16.8759V16.6159L10.0332 17.0559C10.4332 17.1359 10.8332 17.1759 11.2332 17.1759C12.0132 17.1759 12.7932 17.0359 13.5331 16.7559L17.3132 15.3359C17.6132 15.2159 17.7932 14.9359 17.7932 14.6159V14.3759C17.7932 14.1559 17.6932 13.9359 17.5132 13.7959H17.5135ZM12.8136 9.23594V10.7559L12.3736 10.3759C12.3336 10.3359 12.2936 10.3359 12.2336 10.3359C12.1736 10.3359 12.1336 10.3559 12.0936 10.3759L11.6536 10.7559V9.23594H12.8136ZM9.7937 9.23594H11.2937V11.1959C11.2937 11.2759 11.3337 11.3359 11.4137 11.3759C11.4937 11.4159 11.5737 11.3959 11.6337 11.3359L12.2737 10.7759L12.9137 11.3359C12.9537 11.3759 12.9937 11.3759 13.0537 11.3759C13.0737 11.3759 13.1137 11.3759 13.1337 11.3559C13.2137 11.3159 13.2537 11.2559 13.2537 11.1759V9.21594H14.7537V14.0159L13.2137 14.2959C13.1937 14.2159 13.1937 14.1559 13.1937 14.0759C13.1937 13.8759 13.1137 13.6759 12.9537 13.5359C12.8137 13.3959 12.5937 13.3159 12.3937 13.3359L9.7937 13.4759V9.23594ZM7.25382 16.6961H6.59382V13.2161H7.25382V16.6961ZM17.3937 14.6361C17.3937 14.7961 17.2937 14.9161 17.1737 14.9761L13.3936 16.3961C12.3536 16.7961 11.2136 16.8961 10.1136 16.6761L7.6537 16.2161V13.9961L12.4336 13.7161C12.5336 13.7161 12.6336 13.7361 12.6936 13.8161C12.7736 13.8761 12.8136 13.9761 12.8136 14.0761C12.8136 14.2561 12.6936 14.3961 12.5136 14.4161H12.4936L11.2136 14.5561C11.1136 14.5761 11.0336 14.6761 11.0336 14.7761C11.0536 14.8761 11.1336 14.9561 11.2336 14.9561H11.2536L12.5336 14.8161L16.9935 14.0361C17.0935 14.0161 17.1935 14.0361 17.2735 14.1161C17.3535 14.1761 17.3935 14.2961 17.3935 14.3961L17.3937 14.6361Z"
        fill="#A15000"
      />
      <defs>
        <filter
          id="filter0_d_5669_2"
          x="0"
          y="0.140625"
          width="24"
          height="24.2891"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5669_2"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5669_2"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default QuantityReceived;
